import { render } from "./ProfilesFilterInCol.vue?vue&type=template&id=b2287b62&ts=true"
import script from "./ProfilesFilterInCol.vue?vue&type=script&lang=ts"
export * from "./ProfilesFilterInCol.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__